import { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
    Menu,
    MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
    DataGrid,
    Column,
    FilterRow,
    HeaderFilter,
    LoadPanel,
    Paging,
    Scrolling,
    SearchPanel,
    Toolbar,
    Item,
} from "devextreme-react/data-grid";

import { dataGridConfig } from "../../../constants";
import { convertFormatDate } from "../../../util/Utils";
import { ExecutionDetailsModal } from "../ExecutionDetailsModal/ExecutionDetailsModal";
import "./RolloverInfoModal.scss";

interface RolloverInfoModalProps {
    open: boolean;
    onClose: () => void;
    rolloverId?: number;
    rows: any[];
    pending: boolean;
    onDetailsClick?: (row: any) => void;
}

export const RolloverInfoModal = ({
    open,
    onClose,
    rolloverId,
    rows,
    pending,
    onDetailsClick,
}: RolloverInfoModalProps) => {

    const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null);
    const [activeMenuRow, setActiveMenuRow] = useState<any>(null);
    const [isExecutionDetailsOpen, setIsExecutionDetailsOpen] = useState(false);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            className="hq-modal cui-c_modal rollover-info-modal"
        >
            <DialogTitle className="cui-c_modal-title hq-title">
                Restore Audit History
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    className="modal_button-cancel"
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent className="cui-c_modal-body">
                <div className="rollover-info-modal__section">
                    <div className="rollover-info-modal__grid-container">
                        <DataGrid
                            {...dataGridConfig}
                            dataSource={rows}
                            keyExpr="id"
                            noDataText={pending ? "Loading..." : "No data"}
                            wordWrapEnabled
                            rowAlternationEnabled
                            showBorders={true}
                        >
                            <LoadPanel enabled={false} />
                            <Scrolling mode="standard" />
                            <FilterRow visible />
                            <HeaderFilter visible />
                            <Paging enabled defaultPageSize={10} />
                            <Toolbar>
                                <Item name="searchPanel" location="after" />
                            </Toolbar>
                            <SearchPanel visible placeholder="Search..." />
                            <Column dataField="date" caption="Date" minWidth={160} alignment="left"
                                cellRender={(e) => <>{convertFormatDate(e.data.date, "MM/DD/YYYY")}</>}
                            />
                            <Column dataField="initiatedBy" caption="Initiated By" minWidth={200} alignment="left" />
                            <Column dataField="taxYear" caption="Tax Year" minWidth={100} alignment="left" />
                            <Column
                                alignment="center"
                                caption={""}
                                allowEditing={false}
                                cellRender={(e) => (
                                    <div className="hq-action-menu-cell">
                                        <IconButton
                                            size="small"
                                            onClick={(ev) => {
                                            setMenuAnchorEl(ev.currentTarget as HTMLElement);
                                            setActiveMenuRow(e.data);
                                        }}
                                            className="hq-action-button"
                                            aria-label="row actions"
                                        >
                                            <MoreVertIcon fontSize="small" />
                                        </IconButton>
                                    </div>
                                )}
                            />
                        </DataGrid>

                        <Menu
                            id="row-actions-menu"
                            anchorEl={menuAnchorEl}
                            open={Boolean(menuAnchorEl)}
                            onClose={() => setMenuAnchorEl(null)}
                            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                            transformOrigin={{ vertical: "top", horizontal: "left" }}
                            disableScrollLock
                        >
                            <MenuItem onClick={() => {
                                setMenuAnchorEl(null);
                                setIsExecutionDetailsOpen(true);
                            }}>Rollover Execution Details</MenuItem>
                        </Menu>
                    </div>
                </div>
            </DialogContent>
            <DialogActions className="cui-c_modal-footer">
                <Button onClick={onClose} className="hq_button hq_button-secondary">
                    Close
                </Button>
            </DialogActions>

            <ExecutionDetailsModal
                open={isExecutionDetailsOpen}
                onClose={() => setIsExecutionDetailsOpen(false)}
                rolloverId={activeMenuRow?.id}
            />
        </Dialog>
    );
};
